module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', [_c('popup', {
    attrs: {
      "show": _vm.popup.show,
      "closePopup": _vm.closePopup,
      "action": _vm.popup.action,
      "size": _vm.popup.size,
      "type": _vm.popup.type,
      "title": _vm.popup.title,
      "content": _vm.popup.content
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "show": _vm.alert.show,
      "placement": "top-right",
      "type": "success",
      "dismissable": true,
      "width": "200px",
      "duration": 1500,
      "close": _vm.closeAlert
    }
  }, [_vm._v(_vm._s(_vm.alert.content))])], 1), _vm._v(" "), _c('h1', [_vm._v("Welcome to Invasion!")]), _vm._v(" "), _c('p', [_vm._v("\n    This is a game based on Risk®. If you know how to play Risk, you should have no problem with this game. If not, here are a few pointers:\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n  The map is divided into 90 territories, in 9 regions. Each region is a different color, and has a different score, indicated by the number in the round badge. The goal of the game is to conquer every territory on the map. You will be given troops at the beginning of the game to defend your position. Decide which regions you have the best chance of conquering, and add your troops there.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    At the beginning of each turn you will also recive troops, based on how many territories and regions you have. At the end of each turn you will recieve a card if you conquered at least one territory on that turn. Cards can be turned in at the beginning of the turn, or after eliminating another player. The number of troops for a set of cards starts at 4, and goes up every time a set is turned in. When you eliminate a player, you get all their cards.\n  ")]), _vm._v(" "), _c('p', [_vm._v("Hint: pressing the \"R\" key will repeat the last attack you made.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Start New Game")]), _vm._v(" "), _c('h3', [_vm._v("Saved Games:")]), _vm._v(" "), (_vm.edit) ? _c('ul', _vm._l((_vm.games), function(game, id) {
    return _c('li', [_c('button', {
      staticClass: "btn btn-default btn-lg stretch"
    }, [_vm._v("\n        " + _vm._s(game.name) + "\n        "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.renameGame(id)
        }
      }
    }, [_vm._v("rename")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.confirmDelete(id)
        }
      }
    }, [_vm._v("delete")])])])])
  }), 0) : _c('ul', {
    attrs: {
      "id": "col"
    }
  }, _vm._l((_vm.games), function(game, id) {
    return _c('li', [_c('button', {
      staticClass: "btn btn-default btn-lg",
      on: {
        "click": function($event) {
          return _vm.startGame(id)
        }
      }
    }, [_vm._v(_vm._s(game.name))])])
  }), 0), _vm._v(" "), (_vm.games.length === 0) ? _c('div', [_c('i', [_vm._v("No games yet")])]) : (_vm.edit) ? _c('div', [_c('a', {
    on: {
      "click": _vm.closeEdit
    }
  }, [_vm._v("Done")])]) : _c('div', [_c('a', {
    on: {
      "click": _vm.editGames
    }
  }, [_vm._v("Edit games")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-753e35f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard.vue
// module id = 204
// module chunks = 0